(function(){ 
  window.onload=function(){
    document.getElementById('loading-mask').className = ''
  }
})()